// ============================================================================
// Supply Management — shared sub-navigation strip.
// Anchors the 4 Phase-1 views (Requests / Approvals / Orders / Catalog) on
// every supply-management page. Renders as a horizontal tab strip that
// collapses to a horizontally-scrollable row on phones. The Approvals tab is
// only shown to roles that can approve (account_manager / executive /
// superuser); for everyone else it stays hidden because the queue would
// be empty anyway.
// ============================================================================

import { SUPPLY_APPROVERS } from '../../shared/role-gates';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../shared/auth';

const TABS = [
  { to: '/supply', label: 'Requests', end: true },
  {
    to: '/supply/approvals',
    label: 'Approvals',
    roles: SUPPLY_APPROVERS,
  },
  { to: '/supply/orders', label: 'Orders' },
  { to: '/supply/catalog', label: 'Catalog' },
  // 2026-09-09 — which building uses which chemical, and the typed-in names
  // waiting on a catalogue decision. Open to every employee: reading chemicals
  // has been open since the table was built.
  { to: '/supply/chemicals', label: 'Chemicals' },
  // 2026-09-23 — dialysis chemical stock: how much is where, how fast it goes,
  // when to reorder, and what each clinic costs. Every app user logs and edits.
  { to: '/supply/stock', label: 'Chemical stock' },
];

export function SupplySubNav() {
  const { profile } = useAuth();
  const role = profile?.role;

  return (
    <nav className="mb-4 -mx-4 overflow-x-auto sm:mx-0">
      <ul className="flex min-w-max items-center gap-1 px-4 sm:px-0">
        {TABS.map((tab) => {
          if (tab.roles && !tab.roles.includes(role as (typeof tab.roles)[number])) {
            return null;
          }
          return (
            <li key={tab.to}>
              <NavLink
                to={tab.to}
                end={tab.end}
                className={({ isActive }) =>
                  [
                    'inline-flex items-center rounded-full px-3 py-1.5 text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-tcs-inverse text-tcs-inverse-ink'
                      : 'border border-tcs-border bg-tcs-surface text-tcs-text-secondary hover:bg-tcs-bg',
                  ].join(' ')
                }
              >
                {tab.label}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
